import { useQuery } from "@tanstack/react-query";
import { getImplementedOpportunities } from "@/helpers/apis";
import { GET_IMPLEMENTED_OPPORTUNITIES_DATA } from "../../constants";
import type { OpportunitiesFilters } from "../../schemas";

interface UseDiscoverImplementedOpportunitiesQueryProps {
  filterParams: OpportunitiesFilters;
  isInitialized: boolean;
  enabled?: boolean;
}

/**
 * Fetches opportunities the user has marked IMPLEMENTED from the
 * dedicated /opportunities/implemented endpoint. The "Implemented
 * Opportunities" tab is the only consumer — the regular Opportunities
 * tab keeps its own untouched query.
 *
 * `enabled` lets callers defer the fetch until the user actually opens
 * the tab, so we don't pay for the read on first /discover load.
 */
export const useDiscoverImplementedOpportunitiesQuery = ({
  filterParams,
  isInitialized,
  enabled = true,
}: UseDiscoverImplementedOpportunitiesQueryProps) => {
  return useQuery({
    queryKey: [GET_IMPLEMENTED_OPPORTUNITIES_DATA, filterParams],
    queryFn: () => getImplementedOpportunities(filterParams),
    enabled: isInitialized && enabled,
  });
};
